module.exports = __webpack_public_path__ + "img/C7.8a0393e4.png";